import { CopyPage } from '../../../../components/icons/icons';
import { copyText } from '../../../../utils/utils';
import { Page, PageKeyword } from '../../../crawler.interface';
import './jobDetailRow.scss';

export interface JobDetailRowProps {
    page: Page;
    handlePageRowCheck: (e: React.ChangeEvent<HTMLInputElement>, page: Page) => void;
}

function JobDetailRow({ page, handlePageRowCheck }: JobDetailRowProps) {

    const pageTypeScoring: JSX.Element[] = [];
    if (page.type_scores) {
        for (const key in page.type_scores) {
            const value = page.type_scores[key as keyof typeof page.type_scores];
            if (value) {
                const confidenceLevel = value >= 85 ? 'High Confidence' : value > 70 ? 'Medium Confidence' : 'Low Confidence';
                const scoreColor = value >= 85 ? 'green' : value > 70 ? 'yellow' : 'red';
                pageTypeScoring.push(
                    <span className={`score-color ${scoreColor}`} key={key} id={`${value}`} title={`${confidenceLevel}`} >
                        {key}
                    </ span >
                );
            }
        }
    }

    const keywords: JSX.Element[] = [];
    if (page.keywords && page?.keywords.length > 0) {
        page.keywords.map((keyword: PageKeyword) => {
            keywords.push(<span className="keyword" key={keyword.id}>{keyword.term}</span>);
        });
    }


    return (
        <div className="job-detail-row index-row" data-testid="job-detail-row">
            <div className="index-row-item uri-row flew-wrap" data-testid="uri-cell">
                <span className="uri" title={page.uri}>
                    <input type="checkbox" checked={page.selected} onChange={(e) => handlePageRowCheck(e, page)} />
                    {page.uri || 'n/a'}
                </span>
                <span className="sub-cell italicized" onClick={() => copyText(page.id.toString())}>
                    <CopyPage />
                    Page ID={page.id}
                </span>
            </div>
            <div className="index-row-item traffic-source-row" data-testid="traffic-source-cell">
                <span className="traffic-source">
                    {page.source || 'n/a'}
                </span>
            </div>
            <div className="index-row-item page-type ellipsis-parent" data-testid="page-type-cell">
                <span className="ellipsis-child">
                    {pageTypeScoring}
                </span>
            </div>
            <div className="index-row-item phrases ellipsis-parent" data-testid="phrase-cell">
                <span className="ellipsis-child">
                    {keywords}
                </span>
            </div>
        </div >
    );
}

export default JobDetailRow;